<template>
    <v-dialog
        v-model="isOpen"
        max-width="420"
        persistent>
        <v-card class="tw-rounded-lg">
            <v-card-title class="tw-flex tw-items-center tw-gap-3 tw-px-6 tw-pt-4">
                <component
                    :is="ClearIcon"
                    class="tw-size-6 tw-text-orange-600" />
                <span>{{ $t('More.clearStorage') }}</span>
            </v-card-title>

            <v-card-text class="tw-py-4">
                <p class="tw-text-sm tw-text-gray-600">
                    {{ $t('More.clearStorageConfirm') }}
                </p>
            </v-card-text>

            <v-card-actions class="tw-px-6 tw-pb-4">
                <v-spacer></v-spacer>
                <Button
                    color="gray"
                    variant="text"
                    @click="onCancel">
                    {{ $t('shared.cancel') }}
                </Button>
                <Button
                class="tw-ml-6"
                    color="primary"
                    :loading="isClearing"
                    variant="flat"
                    @click="onConfirm">
                    {{ $t('shared.clear') }}
                </Button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    import ClearIcon from '@/components/icons/Clear.vue';
    import { watch } from 'vue';

    const props = defineProps<{
        modelValue: boolean;
        isClearing?: boolean;
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: boolean];
        'confirm': [];
        'cancel': [];
    }>();

    const isOpen = ref(false);

    const onConfirm = () => {
        emit('confirm');
    };

    const onCancel = () => {
        emit('cancel');
        isOpen.value = false;
    };

    watch(
        () => props.modelValue,
        (value) => {
            isOpen.value = value;
        },
        { immediate: true }
    );

    watch(
        () => isOpen.value,
        (value) => {
            emit('update:modelValue', value);
        }
    );
</script>

<style scoped></style>
